<template>
  <div class="app">
    <YearsTrack :data="yearsTrack" v-if="yearsTrack" @choiceYear="onChoiceYear"/>
    <GalleryGrid :year="activeYear" :lang="lang" v-show="!gallery && activeYear"
                 @eventChoice="onEventChoice" @dayChoice="onDayChoice" ref="gallery"/>
    <Gallery :activeId="activeId"
             :lang="lang" v-if="gallery && activeId" @galleryQuit="onGalleryClose"/>
  </div>
</template>
<script>

import YearsTrack from '@/components/app-years-track/app-years-track.vue';
import GalleryGrid from '@/components/app-gallery-grid/app-gallery-grid.vue';
import Gallery from '@/components/app-gallery/app-gallery.vue';
import _get from 'lodash.get';

export default {
  name: 'App',
  components: {
    YearsTrack,
    GalleryGrid,
    Gallery,
  },
  data() {
    return {
      yearsTrack: null,
      gallery: false,
      activeId: null,
      activeDay: null,
      activeYear: null,
      lang: 'ru',
    };
  },
  methods: {
    onGalleryClose() {
      this.gallery = false;
    },
    onChoiceYear(year) {
      this.gallery = false;
      this.activeYear = year;
      localStorage.removeItem('activeId');
      this.$refs.gallery.activeDayId = null;
    },
    onDayChoice(id) {
      this.activeDay = id;
    },
    onEventChoice(id) {
      this.gallery = true;
      this.activeId = id;
      this.activeDay = null;
    },

    async getYears() {
      const config = {
        params: {
          lang: this.lang,
        },
      };
      try {
        const result = await this.$api.get('api/gallery/get_years', config);
        if (result) {
          this.yearsTrack = _get(result, 'data.data.records.sections', null);
          this.activeYear = this.yearsTrack[0].id;
        }
      } catch (error) {
        console.log(error);
      }
    },

  },
  created() {
    if (window.location.href.includes('/en/')) {
      this.lang = 'en';
    } else {
      this.lang = 'ru';
    }
  },
  async mounted() {
    await this.getYears();
  },
  destroyed() {
    localStorage.removeItem('activeId');
  },
};

</script>
